import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilestackS3 = _resolveComponent("FilestackS3")!

  return (_openBlock(), _createBlock(_component_FilestackS3, {
    s3path: _ctx.s3BucketPath,
    imageValidation: _ctx.fillerImageValidation,
    renameFileNameToUUID: true,
    acceptedTypes: _ctx.acceptedImageTypes,
    maxSize: 1000 * 1024 * 1024,
    onFileuploaded: _cache[0] || (_cache[0] = files => _ctx.handleFileUpload(files)),
    onInit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('init'))),
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["s3path", "imageValidation", "acceptedTypes"]))
}